import { render, staticRenderFns } from "./deviceExerciseForm.vue?vue&type=template&id=637dbe36&xmlns=true"
import script from "./deviceExerciseForm.vue?vue&type=script&lang=js"
export * from "./deviceExerciseForm.vue?vue&type=script&lang=js"
import style0 from "./deviceExerciseForm.vue?vue&type=style&index=0&id=637dbe36&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports